import React from "react";
import { FieldControl } from "spark-core-dx/components";
import {
  buildResourceDetailsFieldMetadata,
  getValue,
  RESOURCE_DETAILS_FORM_GROUP_ID
} from "../resourceConfigWizardUtils";

export const InfoPair = ({ label, value }) => (
  <div className="resource-wizard__info-pair">
    <span>{label}</span>
    <strong>{value || "Not set"}</strong>
  </div>
);

export const PatternPlaceholder = ({ title, description, facts = [] }) => (
  <div className="resource-wizard__pattern">
    <h3>{title}</h3>
    <p>{description}</p>
    <div className="resource-wizard__pattern-facts">
      {facts.filter(([, value]) => value !== undefined && value !== null && value !== "").map(([label, value]) => (
        <InfoPair key={label} label={label} value={value} />
      ))}
    </div>
  </div>
);

export const LinkedStepHeader = ({ title, description, countText = "", countClassName = "", actions = null }) => {
  const countClasses = ["resource-wizard__linked-step-count", countClassName].filter(Boolean).join(" ");

  return (
    <div className="resource-wizard__linked-step-header">
      <div>
        <div className="resource-wizard__linked-step-title-row">
          <h3>{title}</h3>
          {actions ? <div className="resource-wizard__linked-step-header-actions">{actions}</div> : null}
          {countText ? <small className={countClasses}>{countText}</small> : null}
        </div>
        {description ? <p>{description}</p> : null}
      </div>
    </div>
  );
};

export const StepField = ({ field, value, onChange, disabled }) => {
  const fieldName = getValue(field, "FieldName", "fieldName");
  const fieldMetadata = buildResourceDetailsFieldMetadata(field);
  return (
    <FieldControl
      className="resource-wizard__field-control"
      fieldMetadata={fieldMetadata}
      value={value}
      disabled={disabled}
      groupId={RESOURCE_DETAILS_FORM_GROUP_ID}
      onChange={(nextValue, nextFieldName) => onChange(nextFieldName || fieldName, nextValue)}
    />
  );
};
